var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$style.container, ( _obj = {}, _obj[_vm.$style.loading] = _vm.loading, _obj )],attrs:{"id":"app"}},[(_vm.loading)?_c('LoadScreen'):_c('div',{class:_vm.$style.inner},[_c('h2',{class:_vm.$style.title},[_vm._v("Hello <%= interactive_id %>!")]),_vm._v(" "),_c('Graphic')],1)],1)
var _obj;}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25017b74","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 44
// module chunks = 0